import type { RouteLocationNormalizedLoadedGeneric } from '#vue-router';

export enum ContextViewMode {
  PREVIEW = 'preview',
  EDIT = 'edit',
  STANDALONE = 'standalone',
}

export const getMagnoliaContext = (requestUrl: RouteLocationNormalizedLoadedGeneric) => {
  const isPreviewMode = requestUrl.query.mgnlPreview;
  const isPreviewAsVisitorMode = requestUrl.query.mgnlPreviewAsVisitor;
  if (isPreviewMode === undefined && isPreviewAsVisitorMode === undefined) {
    return ContextViewMode.STANDALONE;
  }
  if (isPreviewMode === 'true' || isPreviewAsVisitorMode === 'true') {
    return ContextViewMode.PREVIEW;
  }
  return ContextViewMode.EDIT;
};

export const useMagnolia = () => {
  const route = useRoute();
  const context = getMagnoliaContext(route);

  return {
    atMagnolia: computed(() => ([ContextViewMode.EDIT, ContextViewMode.PREVIEW].includes(context))),
    atMagnoliaEditor: computed(() => context === ContextViewMode.EDIT),
    atMagnoliaPreview: computed(() => context === ContextViewMode.PREVIEW),
    context,
  };
};
